/**
 * A custom Kendo validator that checks an item against a collection of like items and looks for a duplicate field, such as a name.
 * data-duplicate-ignore-case="true" will ignore case when checking duplicates. By default it is false.
 */
export default function(input) {

    // default validation to true
    var ret = true,

    // look for a data-duplicate attribute on the input
    validate = input.data("duplicate"),

    // look for a data-duplicate-ignore-case attribute on the input
    ignoreCase = !!input.data("duplicateIgnoreCase");

    // if we found the data-duplicate attribute, continue with validation.
    // otherwise, return true to indicate valid
    if (typeof(validate) !== "undefined" && validate !== null && validate !== false) {

        // pull out the other fields of the validator
        let field = input.data("duplicateField"),
            extraField = input.data("duplicateExtraField"),
            ds = input.data("duplicateDataSource"),
            uid = input.data("uid"),
            startValue = input.data("startValue");

        if (!field) {
            console.error("DuplicateValidator field is missing");
        } else if (!ds) {
            console.error("DuplicateValidator data source is missing")
        } else {

            if(uid && ds.data().every(item => item.uid !== uid)) {
                //The DOM doesn't match the datasource(async rendering), so validation can only pass this.
                return true;
            }

            // iterate over the fields in the data source.
            // compare the value from this input to the value from each field.
            // if a duplicate is found, validation fails.
            $.each(ds.data(), function(index, item) {
                let compareValue = item.get(field),
                    compareUid = item.uid;
                if ($.isFunction(compareValue)) {
                    compareValue = compareValue.call(item);
                }

                let newValue = input.val();
                // If ignoring case, lower case the fields to compare
                if(ignoreCase) {
                    startValue = startValue !== undefined ? startValue.toLowerCase() : undefined;
                    compareValue = compareValue.toLowerCase();
                    newValue = newValue.toLowerCase();
                }

                // first, compare the uids of the fields and/or the startValue to the current value of the fields.
                // if they are the same, return true, which is a "continue" operation
                if ((uid !== undefined && uid == compareUid) || (startValue !== undefined && startValue == compareValue)) {
                    return true;
                }

                // next, compare the values
                // if they are equal, set the return value to false indicating a validation error,
                // and return false, which is a "break" operation
                if (compareValue !== undefined && compareValue == newValue && (!extraField || item.get(extraField) == input.attr("data-duplicate-extra"))) {
                    ret = false;
                    return false;
                }
            });
        }
    }

    return ret;
};
